@if (state() === "loading") {
  <app-loading />
}

@if (state() === "error") {
  <app-error-data
    [title]="isArabic() ? 'حدث بعض الخطأ' : 'Something went wrong'"
    [showRetry]="true"
    (retry)="retry.emit()" />
}

@if (state() === "success") {
  <app-tables
    [headerItems]="headerItems"
    [rows]="rows()"
    [currentActions]="currentActions()"
    (actionTrigger)="handleAction($any($event))"
    [isFiltersApplied]="isFiltersApplied()"
    [emptyFilterTitle]="isArabic() ? 'لا توجد تصنيفات تطابق معايير البحث.' : 'No categories match your criteria.'"
    [emptyContentTitle]="isArabic() ? 'لا توجد تصنيفات' : 'No categories found.'"
    [emptyContentDescription]="isArabic() ? 'لا توجد تصنيفات في النظام.' : 'No categories found in the system.'" />

}
